function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
} 

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);


  elementToFocus.focus()
 
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
 
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        document.querySelector('body').classList.add('menu-opening');
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      document.querySelector('body').classList.add('menu-opening');
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    document.querySelector('body').classList.remove('menu-opening');
    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    document.querySelector('body').classList.remove('menu-opening');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
 
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
 
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
     
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    this.sliderLastItem = this.sliderItemsToShow[this.sliderItemsToShow.length - 1];
    if (this.sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItemsToShow[0].clientWidth);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
    
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0])) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderLastItem)) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
    
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderLastItem.clientWidth) : this.slider.scrollLeft - (step * this.sliderLastItem.clientWidth);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {

    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
    
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);

    document.addEventListener('DOMContentLoaded', () => {
      this.updateOptions();
      this.updateMasterId();
      setTimeout(() =>
        this.updateMedia()
      ,500)
    })
  }


  onVariantChange() {
   
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses(); // update 20.12.23 for the bug fix
  
    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
      
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
    }
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });

  }


  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    //include Product Slider
    productSliderupdate(this.currentVariant.featured_media.id)

  }
  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;
  
    if (this.currentVariant && this.currentVariant.available) {
      
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
        
      });
  }


    toggleAddButton(disable = true, text = '', modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;

    const addButton = productForm.querySelector('[name="add"]');
    if (!addButton) return;

    const addButtonText = addButton;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) {
        addButtonText.textContent = text;
      }
    } else {
      addButton.removeAttribute('disabled');
      if (window.variantStrings && window.variantStrings.addToCart) {
        addButtonText.textContent = window.variantStrings.addToCart;
      }
    }
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"]');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
   
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
    
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  // update 20.12.23 added this for the bug fix
  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}
customElements.define('variant-radios', VariantRadios);

//Load Product Page and check current varian product image
function updateId() {
  //Radio
  if(document.querySelectorAll('variant-radios').length > 0){
    document.querySelectorAll('.js-radio-variant').forEach((variant) => {
      if(variant.checked){
        variant.parentNode.closest('.option-grid').previousElementSibling.querySelector('.optionselected').textContent = variant.value;
      }
      variant.addEventListener('click', function(){
        this.parentNode.closest('.option-grid').previousElementSibling.querySelector('.optionselected').textContent = this.parentNode.dataset.name;
      })
    })
  }
  //Select
  if(document.querySelectorAll('variant-selects').length > 0){
    document.querySelectorAll('.option-variant').forEach((variant) => {
      if(variant.selected){
        variant.parentNode.closest('.select').previousElementSibling.lastChild.previousSibling.textContent = variant.value;
      }
    })
    document.querySelectorAll('.select__select').forEach((variant) => {
      variant.addEventListener('change', function(){
        variant.parentNode.closest('.select').previousElementSibling.lastChild.previousSibling.textContent = this.value;
      })
    })
  }
  //Radio
  if(document.querySelectorAll('#radiojson').length === 1){
    this.variantData = this.variantData || JSON.parse(document.querySelector('#radiojson').textContent);
   var varData = this.variantData || JSON.parse(document.querySelector('#radiojson').textContent);
    
    this.currentVariant = this.variantData.find((variant, index) => {
      if(variant.id == document.querySelector('.js-radio-variant[data-id]').dataset.id && variant.featured_image != null){
        //load page choose current image slide
        setTimeout(function(){
          productSliderupdate(variant.featured_media.id)
        },300)
      }
    }); 
    let variable = this.variantData.find((variant, index) => index === 0 && variant.available === false);
    if (!document.querySelector('.js-radio-variant[data-id]').dataset.id && variable){
      this.variantData.find((variant, index) => {
        if(variant.available === true && index === 1){
          if(variant.featured_image != null){
            productSliderupdate(variant.featured_media.id)
          }
        }
      });
    }
    //Not avaliable radio
    this.variantData = this.variantData.find((variant) => {
      if(variant.available === false ){
        document.querySelectorAll('.js-radio-variant').forEach((item) => {
          if( variant.title === item.value ){
            item.classList.add('novaliable')
          }
        })
      }
    })
  }
  //Select
  if(document.querySelectorAll('#selectjson').length > 0){
    this.variantData = this.variantData || JSON.parse(document.querySelector('#selectjson').textContent);
    
    this.currentVariant = this.variantData.find((variant, index) => {
      if(variant.id == document.querySelector('.option-variant[data-id]').dataset.id && variant.featured_image != null){
        //load page choose current image slide
        setTimeout(function(){
          productSliderupdate(variant.featured_media.id)
        },300)
      }
    }); 
    let variable = this.variantData.find((variant, index) => index === 0 && variant.available === false);
    if (!document.querySelector('.option-variant[data-id]').dataset.id && variable){
      this.variantData.find((variant, index) => {
        if(variant.available === true && index === 1){
          productSliderupdate(variant.featured_media.id)
        }
      });
    }

    this.variantData = this.variantData.find((variant) => {
      if(variant.available === false ){
        document.querySelectorAll('.option-variant').forEach((item) => {
          if( variant.title === item.value ){
            item.classList.add('novaliable')
          }
        })
      }
    })

  }

  //Chek if is current variant avaliable
  if(document.querySelectorAll('input.js-radio-variant').length > 0 ){
    if(document.querySelector('.product-form__submit').disabled === true){
      //show disable radio select
      // update 20.12.23 comment this for the bug fix
      // document.querySelectorAll('.js-radio-variant').forEach((item)=>{
        // if(item.checked === true){
          // item.classList.add('disabled');
        // }
      // })
    }
  }


}updateId();


//Produc Slider Update
function productSliderupdate(variantImageId){
 
   //Swatcher chnage slide
  if(document.querySelectorAll('.gallery-top .swiper-slide').length > 0){
    const hittedIndex = document.querySelector('.imageslide-item[data-thumbid="'+variantImageId+'"]').dataset.index;
 
    document.querySelectorAll('.gallery-top').forEach((item) => {
      const sliderThumbs = new Swiper(item.nextElementSibling.firstElementChild, {
        direction: item.dataset.direction,
        slidesPerView: 4,
        spaceBetween: 10,
        mousewheel: true,
        freeMode: true,
        breakpoints: {
          0: {
            direction: 'horizontal',
          },
          769: {
            direction: item.dataset.direction,

          }
        }
      });
      const sliderImages = new Swiper(item, {
        direction: item.dataset.direction,
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 1000,
        mousewheel: false,
        grabCursor: false,
        allowTouchMove: false,
        thumbs: {
          swiper: sliderThumbs
        },
        navigation: {
          nextEl: item.firstElementChild.nextElementSibling.nextElementSibling.firstElementChild,
          prevEl: item.firstElementChild.nextElementSibling.nextElementSibling.firstElementChild.nextElementSibling,
        },
        keyboard: {
          enabled: true,
          onlyInViewport: true
        },
        pagination: {
          el: item.querySelector('.swiper-pagination'),
          clickable: true,
          type: "progressbar"
        },
        scrollbar: {
          el: item.firstElementChild.nextElementSibling
        },
        breakpoints: {
          0: {
            direction: 'horizontal',
            mousewheel: false,
            allowTouchMove: true,
          },
          769: {
            direction: item.dataset.direction,
            allowTouchMove: false,
          },
        }
      });
      sliderImages.update()
      sliderImages.slideTo(hittedIndex, 0, false)
    })
   
    
  }
}
//Preview product card slider 
function previewCardSlider(){
  if (document.querySelectorAll('.preview-card-slider').length > 0) {
    document.querySelectorAll('.preview-card-slider').forEach((item) => {
        const sliderProductCard = new Swiper(item, { 
          slidesPerView: 1, 
          spaceBetween: 0, 
          speed: 1000,
          grabCursor: true,
          navigation: {
              nextEl: item.firstElementChild.nextElementSibling.firstElementChild,
              prevEl: item.firstElementChild.nextElementSibling.firstElementChild.nextElementSibling,
          },
          pagination: {
              el: item.firstElementChild.nextElementSibling.lastElementChild,
              clickable: true,
          },
        });
    })
  }
}previewCardSlider()
//siblings get
const getSiblings = function (elem) {
	// Setup siblings array and get the first sibling
	let siblings = [];
	let sibling = elem.parentNode.firstChild;
	// Loop through each sibling and push to the array
	while (sibling) {
		if (sibling.nodeType === 1 && sibling !== elem) {
			siblings.push(sibling);
		}
		sibling = sibling.nextSibling
	}
	return siblings;
};


//Chnage image Card product preview
function chnageImageCardProdactPreview(){
  if( document.querySelectorAll('.preview-card').length > 0 ){

    document.querySelectorAll('.preview-card').forEach((card)=>{
      // mobile variants opener
      const customVariantsWrapper = card.querySelector('.custom-variants');
      const mobileVariantsOpenButton = card.querySelector('.custom-variants__open-button');
      const mobileVariantsCloseButton = card.querySelector('.custom-variants__close-button');
      const mobileVariantsOverlay = card.querySelector('.custom-variants__overlay');

      function variantsWrapperClickHandler(button, wrapper, add = false) {
        if (button) {
          button.addEventListener('click', () => {
            if (wrapper) {
              if (add) {
                wrapper.classList.add('show');
              } else {
                wrapper.classList.remove('show');
              }
            }
          });
        }
      }

      variantsWrapperClickHandler(mobileVariantsOpenButton, customVariantsWrapper, true);
      variantsWrapperClickHandler(mobileVariantsCloseButton, customVariantsWrapper);
      variantsWrapperClickHandler(mobileVariantsOverlay, customVariantsWrapper);
      // END mobile variants opener

      if(card.dataset.imagechnage != 'false' || card.dataset.updateslide != 'false'){
        
        if(card.querySelectorAll('.preview-card .custom-variants__color-items').length > 0){

          card.querySelectorAll('.custom-variants__color-item').forEach((item)=>{
            item.addEventListener("click", chnageMouseover);
            item.addEventListener("click", showVariantsForm);

            //show variants form
            function showVariantsForm(event){
              const formId = event.target.dataset.productid;
              const productCard = event.target.closest('.preview-card');
              const productVariantsForms = productCard.querySelectorAll('preview-card-form');

              productVariantsForms.forEach(form => {
                form.classList.remove('active');

                if (form.dataset.productid == formId) {
                  form.classList.add('active');
                }
              })
            }
            //mouseover
            function chnageMouseover(event){
              const previewCard = event.target.closest('.preview-card');

              //active color
              card.querySelectorAll('.custom-variants__color-item').forEach(i => i.classList.remove('active'));
              event.target.classList.add('active');
              event.preventDefault();

              if (previewCard) {
                //sold out badge
                const sizeForm = previewCard.querySelectorAll('.custom-variants__size-form')[event.target.dataset.index];
                const sizeItems = sizeForm.querySelectorAll('button');
                const soldOutWrapper = previewCard.querySelector('.sticker-wrp');

                let isEnabled = true;

                if (sizeItems) {
                  sizeItems.forEach(item => {
                    if (!item.hasAttribute('disabled')) {
                      isEnabled = false;
                    }
                  });
                }
                if (soldOutWrapper) {
                  if (isEnabled) {
                    soldOutWrapper.style.display = 'block';
                  } else {
                    soldOutWrapper.style.display = 'none';
                  }
                }


                //new price
                const newPrice = event.target.dataset.price;
                const priceWrapper = previewCard.querySelector('.price-item');
                priceWrapper.innerHTML = newPrice;

                //change image without slider
                if(card.closest('.preview-card').dataset.imagechnage != 'false'){
                  //check if product image added
                  if(previewCard.querySelectorAll('.card_image .main-preview-img').length > 0){
                    previewCard.querySelector('.card_image .main-preview-img').setAttribute('srcset',event.target.dataset.imagerate);
                  }
                  if(previewCard.querySelectorAll('.card_image .main-second-img').length > 0){
                    previewCard.querySelector('.card_image .main-second-img').setAttribute('srcset',event.target.dataset.secondimagerate);
                  }
                  previewCard.querySelector('.card_image .card-medialink').setAttribute('href',event.target.dataset.url);
                  previewCard.querySelector('.card-title-link').setAttribute('href',event.target.dataset.url);
                }
              }
    
              //chnage image in slider
              if(item.closest('.preview-card').dataset.updateslide != 'false' && card.closest('.preview-card-slider')){
                event.target.parentNode.parentNode.firstElementChild.setAttribute('href',event.target.dataset.url);
                // check if slider has
                if(event.target.parentNode.parentNode.parentNode.querySelectorAll('.card_image .preview-card-slider .swiper-wrapper').length > 0){
                  Array.from(event.target.parentNode.parentNode.parentNode.querySelector('.card_image .preview-card-slider .swiper-wrapper').children)
                  .find((slide) => {
                    if(slide.dataset.id == event.target.dataset.mediaid){
                      const speccliseUpdate = new Swiper(event.target.parentNode.parentNode.parentNode.querySelector('.preview-card-slider'),{
                        navigation: {
                            nextEl: event.target.parentNode.parentNode.parentNode.querySelector('.card_image .preview-card-slider .swiper-button-next'),
                            prevEl: event.target.parentNode.parentNode.parentNode.querySelector('.card_image .preview-card-slider .swiper-button-prev'),
                            
                        },
                        pagination: {
                            el: event.target.parentNode.parentNode.parentNode.querySelector('.card_image .preview-card-slider .swiper-pagination'),
                            clickable: true,
                        },
                      });
                      speccliseUpdate.slideTo(slide.dataset.index, 600, false);
                      speccliseUpdate.update();
                    }
                  })
                }// end check if slider has
              }
    
              let getSiblingsitem = getSiblings(event.target);
              getSiblingsitem.forEach((siblings)=>{
                //siblings item remove hovered
                siblings.classList.remove('hovered')
              })
              //add current item hovered class
              event.target.classList.add('hovered'); 
    
            }//end hover function
    
    
    
          })//end foreach
    
    
        }//end check color swatcher has
        
      }
      
    })//for each status false

} 
}chnageImageCardProdactPreview();

function setCardProductPreviewLink() {
  const products = document.querySelectorAll('#product-grid .grid__item');
  const changeUrl = (element, button) => {
    const checked = element.querySelector('.card_optioncolor .coloritem.hovered');

    if (checked) {
      button.href = checked.dataset.url;
    }
  }

  if (products) {
    products.forEach(product => {
      const options = product.querySelectorAll('.card_optioncolor .coloritem');
      const previewLinkButton = product.querySelector('.js-preview-product');

      if (options && previewLinkButton) {
        // set initial link
        changeUrl(product, previewLinkButton);

        // when change
        options.forEach(option => option.addEventListener('click', () => {
          changeUrl(product, previewLinkButton);
        }));
      }
    });
  }
}setCardProductPreviewLink();

//Ajax pagination collection page
function ajaxPagination(){

  if(document.querySelectorAll('#moreload').length > 0){
  
  let counter = 2;
  let pages = document.querySelector('#moreload').dataset.pagemax;
  let maxCount = Number(pages)+1;

  //infinixscroll
  if (document.querySelectorAll(".infinixscroll").length > 0) {

    let scrollEventCatcher = new IntersectionObserver(function (getProduct) {

      getProduct.forEach(function (event) {

        if (event.isIntersecting == true) {
          
          //check url filter
          let getUrl
          if (!location.search) {
            getUrl = location.href + "?page=" + counter
          } else {
            getUrl = location.href + "&page=" + counter
          }
        
          //Add disabled button
          document.querySelector("#moreload").disabled = true
          //Remove class new load product card
          document.querySelectorAll(".grid__item").forEach((item) => {
            item.classList.remove("loaded-product")
          })

    
          setTimeout(function () {
            $.ajax({
              url: getUrl,
              type: "GET",
              beforeSend: function () {
                //add disable button
              },
              complete: function () {
                //Preview product card slider -- global js
                previewCardSlider()
                // chnage image card when click color swatcher -- global.js
                chnageImageCardProdactPreview()
                //preview product 
                clickPreviewProductPopup()
              },
              success: function (data) {
                counter++
                
                let html_div = document.createElement("div")
                html_div.innerHTML = data

                //add class new load product card
                html_div.querySelectorAll(".grid__item").forEach((item) => {
                  item.classList.add("loaded-product")
                })

                let loadedData = html_div.querySelector('#product-grid').innerHTML;
                document.querySelector("#product-grid").innerHTML += loadedData;
                // add new product
    
                //remove disable button
                document.querySelector("#moreload").disabled = false
                // remove button
                if (counter == maxCount) {
                  document.querySelector("#moreload").parentNode.remove()
                }
              },
            }) //end ajax request
          }, 1000)
        }
      })
    })
    //infinix button catcher
    scrollEventCatcher.observe(document.querySelector('.infinixscroll'))
  }



  //click load products ajax
  document.querySelector('#moreload').addEventListener('click', function(e) {
    e.preventDefault();
    //check url filter
    let getUrl;
    if(!location.search){
      getUrl = location.href+'?page='+counter;
    }else{
      getUrl = location.href+'&page='+counter;
    }

    //Add disabled button
    document.querySelector('#moreload').disabled = true;
    //Remove class new load product card
    document.querySelectorAll('.grid__item').forEach((item)=>{
      item.classList.remove('loaded-product')
    })

    setTimeout(function(){

      $.ajax({
        url: getUrl,
        type:'GET',
        beforeSend: function(){
          //add disable button
          
        },
        complete: function(){
          //Preview product card slider -- global js
          previewCardSlider()
          // chnage image card when click color swatcher -- global.js
          chnageImageCardProdactPreview()
          //preview product 
          clickPreviewProductPopup()
        },
        success: function(data){

          counter++;
      
          let html_div = document.createElement('div');
            html_div.innerHTML = data;

          //add class new load product card
          html_div.querySelectorAll('.grid__item').forEach((item)=>{
            item.classList.add('loaded-product')
          })

          let loadedData = html_div.querySelector('#product-grid').innerHTML;
          // add new product
          document.querySelector("#product-grid").innerHTML += loadedData;
    
          //remove disable button
          document.querySelector('#moreload').disabled = false;
          // remove button
          if(counter == maxCount ) {
            document.querySelector('#moreload').parentNode.remove();
          }

        }
      });//end ajax request

    },1000)//end setTimeout

  });//end click
}

}ajaxPagination();



//Ajax pagination category page
function ajaxPaginationBlog(){


  if(document.querySelectorAll('#moreload_posts').length > 0){
  
  let counter = 2;
  let pages = document.querySelector('#moreload_posts').dataset.pagemax;
  let maxCount = Number(pages)+1;


  //infinixscroll posts
  if (document.querySelectorAll(".infinixscroll").length > 0) {

    let scrollEventCatcher = new IntersectionObserver(function (getProduct) {

      getProduct.forEach(function (event) {

        if (event.isIntersecting == true) {

          //check url filter
          let getUrl
          if (!location.search) {
            getUrl = location.href + "?page=" + counter
          } else {
            getUrl = location.href + "&page=" + counter
          }

          //Add disabled button
          document.querySelector('#moreload_posts').disabled = true;
          //Remove class new load post card
          document.querySelectorAll('.article-column').forEach((item)=>{
            item.classList.remove('loaded-post')
          })

    
          setTimeout(function () {
            $.ajax({
              url: getUrl,
              type: "GET",
              beforeSend: function () {
                //add disable button
              },
              complete: function () {
                //Preview product card slider -- global js
                previewCardSlider()
                // chnage image card when click color swatcher -- global.js
                chnageImageCardProdactPreview()
                //preview product 
                clickPreviewProductPopup()
              },
              success: function (data) {
                counter++;

                let html_div = document.createElement('div');
                  html_div.innerHTML = data;

                //add class new load post card
                html_div.querySelectorAll('.article-column').forEach((item)=>{
                  item.classList.add('loaded-post')
                })

                let loadedData = html_div.querySelector('#blog-articles-grid').innerHTML;
                // add new post
                document.querySelector("#blog-articles-grid").innerHTML += loadedData;
          
                //remove disable button
                document.querySelector('#moreload_posts').disabled = false;
                // remove button
                if(counter == maxCount ) {
                  document.querySelector('#moreload_posts').parentNode.remove();
                }
              },
            }) //end ajax request
          }, 1000)
        }
      })
    })
    //infinix button catcher
    scrollEventCatcher.observe(document.querySelector('.infinixscroll'))
  }


  document.querySelector('#moreload_posts').addEventListener('click', function(e) {
    e.preventDefault();
    //check url filter
    let getUrl;
    if(!location.search){
      getUrl = location.href+'?page='+counter;
    }else{
      getUrl = location.href+'&page='+counter;
    }

    //Add disabled button
    document.querySelector('#moreload_posts').disabled = true;
    //Remove class new load post card
    document.querySelectorAll('.article-column').forEach((item)=>{
      item.classList.remove('loaded-post')
    })

    setTimeout(function(){

      $.ajax({
        url: getUrl,
        type:'GET',
        beforeSend: function(){
          //add disable button
          
        },
        complete: function(){
   
        },
        success: function(data){

          counter++;

          let html_div = document.createElement('div');
            html_div.innerHTML = data;

          //add class new load post card
          html_div.querySelectorAll('.article-column').forEach((item)=>{
            item.classList.add('loaded-post')
          })

          let loadedData = html_div.querySelector('#blog-articles-grid').innerHTML;
          // add new post
          document.querySelector("#blog-articles-grid").innerHTML += loadedData;
    
          //remove disable button
          document.querySelector('#moreload_posts').disabled = false;
          // remove button
          if(counter == maxCount ) {
            document.querySelector('#moreload_posts').parentNode.remove();
          }

        }
      });//end ajax request

    },1000)//end setTimeout

  });//end click
}

}ajaxPaginationBlog();




//load fetch product card in popup
function clickPreviewProductPopupFetch(fetchUrl){

    //create div container for ajax loaded product
    let html_div_popup = document.createElement('div');
    html_div_popup.classList.add('js-get-productdetail');

    html_div_popup.classList.add('loading')
    html_div_popup.innerHTML = `
    <svg aria-hidden="true" focusable="false" width="15" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
      <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
    </svg>
    `
    document.querySelector('body').append(html_div_popup)

      //fetch product page
      fetch(fetchUrl)
      .then(response => response.text())
      .then(data => {

        //create div container for ajax loaded product and find product detail info
        let html_div = document.createElement('div');
        html_div.innerHTML = data;
        
        let html_dom = html_div.querySelector('#product-detail-info').innerHTML;
        
        //remove loading class
        html_div_popup.classList.remove('loading')
        //add ready loaded content
        setTimeout(()=>{
          html_div_popup.classList.add('loaded')
        },300)

        //create iiner div container for ajax loaded product
        let html_div_popup_inner = document.createElement('div');
        html_div_popup_inner.classList.add('js-get-productdetail_inner')
            html_div_popup_inner.innerHTML = html_dom;
           
            if(html_div_popup_inner.querySelector('variant-radios')){
              html_div_popup_inner.querySelector('variant-radios').setAttribute('data-update-url','false');
            }
            html_div_popup_inner.querySelector('.product-imageslide').setAttribute('data-direction','horizontal');
            html_div_popup_inner.querySelectorAll('.product-imageslide a').forEach((item)=>{
              item.addEventListener('click', function(e){
                e.preventDefault();
              })
              item.setAttribute('href','#')
              item.classList.remove('zoom-gallery')
            })
            html_div_popup_inner.querySelector('h1').classList.remove('h2')
            html_div_popup_inner.querySelector('h1').classList.add('h3')
            html_div_popup_inner.querySelector('.js-full-detail').classList.remove('hidden')
            //print ready elements
            html_div_popup.prepend(html_div_popup_inner)
            
        //create div close container for ajax loaded product
        let html_div_popup_close = document.createElement('div');
            html_div_popup_close.classList.add('js-get-productdetail-close')
            html_div_popup_close.innerHTML = `
            <span class="close-product-view">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="icon icon-close"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
            </span>`;
            html_div_popup_inner.prepend(html_div_popup_close);

        document.querySelector('.js-get-productdetail-close').addEventListener('click', function(){
          html_div_popup.classList.remove('loaded')
          setTimeout(()=>{
            document.querySelector('body').classList.remove('overflow-hidden')
            document.querySelector('.js-get-productdetail').remove();
            if(document.querySelectorAll('pickup-availability-drawer').length > 0){
              document.querySelector('pickup-availability-drawer').remove();
            }
          },300)
        })
     
  
        const sliderThumbs = new Swiper('.js-get-productdetail_inner .product-thumbnail', { 
          direction: 'horizontal', 
          slidesPerView: 4,
          spaceBetween: 10,
          freeMode: true, 
          //noSwiping: false,
          breakpoints: { 
            0: { 
              direction: 'horizontal',  
            },
            769: { 
              direction: 'horizontal',  

            }
          }
        });
        const sliderImages = new Swiper('.js-get-productdetail_inner .product-imageslide', { 
          slidesPerView: 1, 
          spaceBetween: 0, 
          speed: 1000,
          mousewheel: true,
          grabCursor: true,
          thumbs: {
            swiper: sliderThumbs
          },
          navigation: {
            nextEl: '.js-get-productdetail_inner .swiper-button-next',
            prevEl: '.js-get-productdetail_inner .swiper-button-prev',
          },
          breakpoints: { 
            0: { 
              direction: 'horizontal',  
              mousewheel: false,
            }
          }
        });
       //upadate variant slider
        updateId();
        //update checkout button
        Shopify.PaymentButton.init(); 
        //add to cart update header counter
        updateCartCounterHeader()
        //get new script links
        if (html_div_popup_inner) {
          const pickupAvailabilityJs = html_div_popup_inner.querySelector('.pickup-availability-jsfile').getAttribute('src');
          const productFormjs = html_div_popup_inner.querySelector('.product-form-jsfile').getAttribute('src');
          let productModalJs = '';
          if(html_div_popup_inner.querySelectorAll('.product-modal-js').length > 0){
            productModalJs = html_div_popup_inner.querySelector('.product-modal-js').getAttribute('src');
          }

          //generate new script links
          const scriptPromise = new Promise((resolve, reject) => {
            const script1 = document.createElement('script');
            html_div_popup_inner.append(script1);
            script1.onload = resolve;
            script1.onerror = reject;
            script1.async = true;
            script1.src = pickupAvailabilityJs;
            //
            const script2 = document.createElement('script');
            html_div_popup_inner.append(script2);
            script2.onload = resolve;
            script2.onerror = reject;
            script2.async = true;
            script2.src = productFormjs;
            //
            const script3 = document.createElement('script');
            html_div_popup_inner.append(script3);
            script3.onload = resolve;
            script3.onerror = reject;
            script3.async = true;
            script3.innerHTML = `${html_div_popup_inner.querySelector('#cariantproductjsopn').innerHTML}`;
            //
            const script4 = document.createElement('script');
            html_div_popup_inner.append(script4);
            script4.onload = resolve;
            script4.onerror = reject;
            script4.async = true;
            script4.src = productModalJs;
          });
        }

        function hideAllProductLink(arr) {
          arr.forEach(el => el.style.display = 'none');
        }

        function setActiveProductLink() {
          const activeOptions = document.querySelectorAll('.option-grid .product-link:checked');

          const allLinks = document.querySelectorAll('.product__info-wrapper .view-full-detail .link_underline');
          const activeOptionsArray = [];

          if (activeOptions) {
            activeOptions.forEach(option => activeOptionsArray.push(option.value))
          }

          if (allLinks) {
            hideAllProductLink(allLinks);

            // function to check if two arrays are identical
            const areArraysEqual = (arr1, arr2) => {
              if (arr1.length !== arr2.length) {
                return false;
              }

              for (let i = 0; i < arr1.length; i++) {
                if (arr1[i] !== arr2[i]) {
                  return false;
                }
              }

              return true;
            }

            allLinks.forEach(link => {
              const checkArr = link.dataset.variantTitle.split(' / ');
              const check = areArraysEqual(checkArr, activeOptionsArray);

              if (check) {
                link.style.display = 'inline-block';
              }
            });
          }
        }

        function setActiveColorValue(activeValue = null) {
          // initial
          if (!activeValue) {
            activeValue = document.querySelector('.option-grid-Color .product-link:checked');
          }

          // after change - set new color name
          if (activeValue.parentNode.parentNode.classList.contains('option-grid-Color')) {
            const activeColorValue = document.querySelector('.form-inpust-Color .color-value-active');

            if (activeColorValue) {
              activeColorValue.textContent = `(${activeValue.parentNode.dataset.name})`;
            }
          }
        }

        const checkboxInputs = document.querySelectorAll(".option-grid");
        setActiveColorValue();
        setActiveProductLink();
        if (checkboxInputs) {
          checkboxInputs.forEach(function (checkbox) {
            checkbox.addEventListener("change", function () {
              const activeValue = checkbox.querySelector('.option-grid .product-link:checked');

              setActiveColorValue(activeValue);
              setActiveProductLink();
            });
          });
        }
      });//end fetch then
}


function removeAllCheckedClasses(items) {
  items.forEach(item => item.classList.remove('checked'));
}

function productSizeChartScript() {
  const section = document.querySelector('.section-size-chart__wrapper');

  if (section) {
    const sizingRegion = section.querySelector('#sizing-region');
    const sizingType = section.querySelector('#sizing-type');
    const sizingSize = section.querySelector('#sizing-size');
    const outputWrapper = section.querySelector('.section-size-chart__output');

    //-------- region click handler + size change handler
    const regionItems = sizingRegion.querySelectorAll('.sizing-region__li');
    const sizeLabels = sizingSize.querySelectorAll('label');

    regionItems.forEach((regionItem, index) => {
      regionItem.addEventListener('click', () => {
        removeAllCheckedClasses(regionItems);
        regionItem.classList.add('checked');

        sizeLabels.forEach(label => {
          const spans = label.querySelectorAll('span');
          spans.forEach((span, i) => {
            if (i === index) {
              span.classList.add('checked');
            } else {
              span.classList.remove('checked');
            }
          })
        })
      });
    });
    //--------END region click handler + size change handler

    //-------- type click handler + info change handler
    const typeItems = sizingType.querySelectorAll('.sizing-type__li');
    const outputDataWrappers = outputWrapper.querySelectorAll('.section-size-chart__output-data-wrapper');

    typeItems.forEach((typeItem, index) => {
      typeItem.addEventListener('click', () => {
        removeAllCheckedClasses(typeItems);
        typeItem.classList.add('checked');

        outputDataWrappers.forEach(outputDataWrapper => {
          outputDataWrapper.querySelectorAll('div').forEach((div, divIndex) => {
            if (divIndex === index) {
              div.classList.add('checked');
            } else {
              div.classList.remove('checked');
            }
          });
        });
      });
    });
    //--------END type click handler + info change handler

    //-------- size click handler
    const sizingSizeLi = sizingSize.querySelectorAll('.sizing-size__li');
    const outputLiItems = outputWrapper.querySelectorAll('li');

    sizingSizeLi.forEach((sizingSizeLiItem, index) => {
      sizingSizeLiItem.addEventListener('click', () => {
        sizingSizeLi.forEach(sSLI => sSLI.classList.remove('checked'));
        sizingSizeLiItem.classList.add('checked');

        outputLiItems.forEach((outputLiItem, i) => {
          if (i === index) {
            outputLiItem.classList.add('checked');
          } else {
            outputLiItem.classList.remove('checked');
          }
        })
      });
    });
    //--------END size click handler
  }
}

function clickProductSizeChartFetch(fetchUrl){

  //create div container for ajax loaded product
  let html_div_popup = document.createElement('div');
  html_div_popup.classList.add('js-get-productsizechart');

  html_div_popup.classList.add('loading')
  html_div_popup.innerHTML = `
    <svg aria-hidden="true" focusable="false" width="15" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
      <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
    </svg>
    `
  document.querySelector('body').append(html_div_popup)

  //fetch product page
  fetch(fetchUrl)
    .then(response => response.text())
    .then(data => {

      //create div container for ajax loaded product and find product detail info
      let html_div = document.createElement('div');
      html_div.innerHTML = data;

      let html_dom = html_div.querySelector('.section-size-chart').innerHTML;

      //remove loading class
      html_div_popup.classList.remove('loading')
      //add ready loaded content
      setTimeout(()=>{
        html_div_popup.classList.add('loaded')
      },300)

      //create inner div container for ajax loaded product
      let html_div_popup_inner = document.createElement('div');
      html_div_popup_inner.classList.add('js-get-productsizechart_inner')
      html_div_popup_inner.innerHTML = html_dom;

      //print ready elements
      html_div_popup.prepend(html_div_popup_inner)

      //create div close container for ajax loaded product
      let html_div_popup_close = document.createElement('div');
      html_div_popup_close.classList.add('js-get-productsizechart-close')
      html_div_popup_close.innerHTML = `
            <span class="close-product-view">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="icon icon-close"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
            </span>`;
      html_div_popup_inner.prepend(html_div_popup_close);

      productSizeChartScript();

      const closeModalHandler = (button) => {
        button.addEventListener('click', function(e){
          e.preventDefault();
          html_div_popup.classList.remove('loaded')
          setTimeout(()=>{
            document.querySelector('body').classList.remove('overflow-hidden')
            document.querySelector('.js-get-productsizechart').remove();
          },100)
        })
      }
      const closeButton = document.querySelector('.js-get-productsizechart-close');
      if (closeButton) {
        closeModalHandler(closeButton);
      }
      const needHelpButton = document.querySelector('.js-get-productsizechart_inner .btn');
      if (needHelpButton) {
        closeModalHandler(needHelpButton);
        needHelpButton.addEventListener('click', () => {
window.open('https://reinaolga.com/en/pages/contact-us', '_blank');

        });
      }

    });//end fetch then
}

//click by preview card link to show product
function clickPreviewProductPopup(){
  if(document.querySelectorAll('.js-preview-product').length > 0){
    document.querySelectorAll('.js-preview-product').forEach((item)=>{
      item.addEventListener('click', function(link){
        link.preventDefault();
        //load fetch product card in popup
        clickPreviewProductPopupFetch(this.getAttribute('href'))

      });
    });
  }
}clickPreviewProductPopup();


function clickProductSizeChartLabel() {
  if(document.querySelectorAll('#OptionLinkToSize').length > 0){
    document.querySelectorAll('#OptionLinkToSize').forEach((item)=>{
      item.addEventListener('click', function(link){
        link.preventDefault();
        //load fetch product card in popup
        clickProductSizeChartFetch(this.getAttribute('href'));
      });
    });
  }
}clickProductSizeChartLabel();

//click by preview card link to show product
if (!customElements.get('preview-card-form')) {
  customElements.define('preview-card-form', class PreviewCardForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

      this.cart = document.querySelector('cart-drawer');
      this.submitButtons = this.querySelectorAll('[type="submit"]');
      this.submitButtons.forEach(button => button.addEventListener('click', this.onSubmitClickHandler.bind(button)))
    }

    onSubmitClickHandler(event){
      const newPrice = event.target.dataset.price;
      const cardWrapper = event.target.closest('.preview-card');
      const customVariantsWrapper = event.target.closest('.custom-variants');
      const buttons = event.target.parentNode.querySelectorAll('[type="submit"]');

      buttons.forEach(button => button.classList.remove('active'));
      event.target.classList.add('active');

      if (cardWrapper) {
        const priceWrapper = cardWrapper.querySelector('.price-item');
        priceWrapper.innerHTML = newPrice;
      }
      if (customVariantsWrapper) {
        customVariantsWrapper.classList.remove('show')
      }
    }
    onSubmitHandler(evt){
      evt.preventDefault();
      this.submitButton = this.form.querySelector('.active[type="submit"]');
      this.inputId = this.form.querySelector('input[name="id"]');

      this.inputId.setAttribute('value', this.submitButton.dataset.variantid)

      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');



      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {

        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);

      }

      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {

          if (response.status) {
            this.handleErrorMessage(response.description);

            this.error = true;
            return;
          } else if (!this.cart) {
            return;
          }
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }

          setTimeout(function() {
            $.getJSON(`${routes.cart_update_url}`, function(cart) {
              if(cart.item_count > 0 && document.querySelectorAll("span.cart-counter").length > 0) {
                document.querySelector("span.cart-counter").classList.remove('hidden');
                document.querySelector("span.cart-counter").innerHTML = cart.item_count;
              }
            });
          }, 700);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.setAttribute('aria-disabled', false);
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        if (errorMessage.email) {
          this.emailErrorMessage = this.querySelector('.recipient-form__email-error-message-wrapper .product-form__error-message');
          if (!this.emailErrorMessage) return;
          this.emailErrorMessage.parentNode.toggleAttribute('hidden', !errorMessage);
          this.emailErrorMessage.textContent = errorMessage.email;
        } else {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  });
}



//Currency Switcher
// function currencySwitcher(){
//   if(document.querySelectorAll('#currency_form').length > 0){
//     document.querySelectorAll('.shopify-currency-form').forEach(function(element) {
//       element.querySelectorAll('.currency-link').forEach((item) => {
//         item.addEventListener('click', function(e){
//           e.preventDefault()
//           item.parentNode.parentNode.parentNode.parentNode.parentNode.querySelector('input[name="currency"]').value = this.getAttribute('data-value')
//           item.parentNode.parentNode.parentNode.parentNode.parentNode.submit();
//         });
//       });

//     });
//   }
// }currencySwitcher();
if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="currency"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }
  );
}

//Update count in cart Header
function updateCartCounterHeader(){
  document.querySelectorAll('.product-form__submit').forEach((item)=>{
    item.addEventListener('click', function(){
      setTimeout(function() { 
        $.getJSON(`${routes.cart_update_url}`, function(cart) {
          if(cart.item_count > 0 && document.querySelectorAll("span.cart-counter").length > 0) {
            document.querySelector("span.cart-counter").classList.remove('hidden');
            document.querySelector("span.cart-counter").innerHTML = cart.item_count;
          }
        }); 
      }, 700);
    });
  })
}updateCartCounterHeader();
 
//close dropdown disclosure list
function closeLoseFocust(){
  if(document.querySelectorAll('.disclosure__button').length > 0){
    window.onclick = function(event) {
 
      if (!event.target.matches('.disclosure__button')) {
        document.querySelectorAll('.disclosure__button').forEach((item)=>{
          item.nextElementSibling.setAttribute('hidden',true)
        })
      }
    }
  }
}closeLoseFocust(); 

//Details custom slide toggle
function detailsCustomSlideToggle(){
  const allDetails = document.querySelectorAll('.deatils-slide-animation');

  if(allDetails.length > 0){

    //reset prevent default details
    allDetails.forEach((item) => {
      item.addEventListener('click', (event) => {
        event.preventDefault();
      });
    });

    allDetails.forEach((details)=>{
      const summary = details.querySelector('summary');
      let contentHeight = summary.nextElementSibling.scrollHeight;

      const summaryDeleteClassHandler = () => {
        allDetails.forEach((otherDetails) => {
          if (otherDetails.querySelector('summary').classList.contains('loading')) {
            otherDetails.querySelector('summary').classList.remove('loading');
          }
        })
      }

      const closeAllDetails = () => {
        allDetails.forEach((otherDetails) => {
          if (otherDetails !== details && otherDetails.hasAttribute('open')) {
            otherDetails.querySelector('summary').nextElementSibling.style.height = '0px';
            otherDetails.classList.add('closing');
            setTimeout(() => {
              otherDetails.removeAttribute('open');
              otherDetails.classList.remove('closing');
              otherDetails.querySelector('summary').nextElementSibling.style.height = '';
            }, 300);
          }
        });
      };

      const openDetails = (summary) => {
        if(!summary.parentNode.classList.contains('closing') && !summary.parentNode.open){
          if (!summary.classList.contains('loading')) {
            closeAllDetails();
          }

          summary.parentNode.setAttribute('open', true);

          //remove preven default by click
          summary.nextElementSibling.addEventListener('click',(evn)=>{
            evn.stopPropagation();
          })
          //get height by click
          contentHeight = summary.nextElementSibling.offsetHeight;
          summary.nextElementSibling.style.height = '0px';

          setTimeout(() => {

            if(window.jQuery){
              $(summary).next().animate({'height':contentHeight+'px'},100)
            }else{
              summary.nextElementSibling.style.height = contentHeight+'px';
            }

            summary.nextElementSibling.removeAttribute('style')
            summary.parentNode.classList.add("closing");

          }, 60);

        }else{
          if(window.jQuery){
            $(summary).next().animate({'height':'0px'},50)
          }else{
            summary.nextElementSibling.style.height = '0px';
          }
          summary.parentNode.classList.remove("closing");
          setTimeout(() => {
            summary.nextElementSibling.removeAttribute('style')
            summary.parentNode.removeAttribute('open', true);

          }, 300);
        }
      }

      if(summary.dataset.default){
        openDetails(summary);
      }

      summary.addEventListener('click', function(event){
        summaryDeleteClassHandler()
        openDetails(summary);
      });
    })
  }
}detailsCustomSlideToggle();

//Scroll animation
var animationScrollTo = new IntersectionObserver(function(entries, animationScrollTo) {
  entries.forEach(function(entry) {
    if (entry.isIntersecting) {
      var element = entry.target;
      element.classList.add('animated', element.dataset.animation);
      animationScrollTo.unobserve(element);
    }
  });
});
var scrollAnimationElements = document.querySelectorAll(".scrollanimation:not(.animated)");
scrollAnimationElements.forEach(function(element) {
  animationScrollTo.observe(element);
});
//mac os fixes class
if(navigator.platform.match('Mac') !== null) {
  document.querySelector('body').classList.add('osx-fixed')
}
//ios
if (navigator.userAgent.match(/(iPod|iPhone|iPad)/)) {
  document.querySelector('body').classList.add('osx-fixed')
}